export const ReceivePackageActions = {
    INDUCT_PACKAGE:"INDUCT_PACKAGE",
    INDUCT_PACKAGE_RESPONSE:"INDUCT_PACKAGE_RESPONSE",
    INDUCT_PACKAGE_RESPONSE_ERROR:"INDUCT_PACKAGE_RESPONSE_ERROR",
    RESET_INDUCT_STATE:"RESET_INDUCT_STATE",
    LOADING:"LOADING"
};